import { ControlConstants } from "../../control/constant/ControlConstants";
import { SpriteProperties } from "../../control/properties/SpriteProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { CommonLang } from "../lang/CommonLang";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { CommonStyle } from "../style/CommonStyle";
import { AbstractViewProperties } from "./AbstractViewProperties";
/**
 * AbstractDemoPlayProperties.ts
 */
export class AbstractDemoPlayProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.labelProperties.equals(other.labelProperties);
    }
    setDefaultValues() {
        this.backgroundProperties = new SpriteProperties(CommonStyle.DEMO_PLAY_BACKGROUND, CommonStyle.MODULE);
        this.labelProperties = new TextFieldProperties(CommonFontStyle.DEMO_PLAY_LABEL, null, CommonLang.DEMO_PLAY, ControlConstants.CENTER);
    }
}
//# sourceMappingURL=AbstractDemoPlayProperties.js.map